import { Component, Input, forwardRef, ViewChild, ElementRef, Renderer, AfterViewInit } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
/**
 * fc-textareaå¤§ææ¬æ¡
 * 
 * éè¿é¼ æ æé®çè¾å¥åå®¹ï¼æ¯æåºç¡çè¡¨ååçåè£ã
 * 
 * éè¦ç¨æ·è¾å¥è¡¨åååå®¹æ¶ã
 * 
 * æä¾ç»ååï¼å¸¦æç´¢çè¾å¥æ¡ï¼è¿å¯ä»¥è¿è¡å¤§å°éæ©ã
 * 
 */
@Component({
    selector: 'fc-textarea',
    template: `<ng-container *ngIf="fcShowLabel==='N'" (blur)="_blur($event)">
    <div nz-row>
        <div nz-col nzSpan="23" class="fuzzy-dropdown form-explain">
            <textarea nz-input  *ngIf="fcShowLabel==='N'" #infocus  [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)"
                [placeholder]="fcPlaceHolder" [nzSize]="fcSize" [disabled]="_disabled " (blur)="_blur($event)" (focus)="_focus($event)"
                (click)="_click($event)" (keyup)="_keyup($event)" [readonly]="_readonly" [nzAutosize]="_Autosize"
                [rows]="_row" [maxlength]="_maxlen" [minlength]="_minlen">
            </textarea>
            <ul class="fuzzy-dropdown-menu">
                <li *ngFor="let data of _selectData" class="fuzzy-dropdown-item" (click)="innerValue=data[fcFieldCode];_selectData=[];event('selected',data[fcFieldCode]);">
                    <span class="fuzzy-dropdown-item-left">{{data[fcFieldCode]}}</span>
                    <span class="fuzzy-dropdown-item-right">{{data[fcLabelCode]}}&nbsp;{{data[fcValueCode]}}</span>
                </li>
            </ul>
        </div>
        <div nz-col nzSpan="1"></div>
    </div>
</ng-container>
<div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
    <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
    <div nz-col [nzSpan]="valueSpan">
        <textarea nz-input [(ngModel)]="innerValue" #infocus  (ngModelChange)="checkValidator($event)" [placeholder]="fcPlaceHolder"
            [nzSize]="fcSize" [disabled]="_disabled " (blur)="_blur($event)" (focus)="_focus($event)" [readonly]="_readonly"
            (click)="_click($event)" (keyup)="_keyup($event)" [nzAutosize]="_Autosize" [rows]="_row"
            [maxlength]="_maxlen" [minlength]="_minlen"></textarea>
        <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
            {{fcHelp}}
        </div>
        <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
            <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                <div class="explain-tips">{{_validator.errorMessages.required}}</div>
            </div>
            <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
            </div>
            <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
            </div>
        </div>
        <ul class="fuzzy-dropdown-menu">
            <li *ngFor="let data of _selectData" class="fuzzy-dropdown-item" (click)="innerValue=data[fcFieldCode];_selectData=[];event('selected',data[fcFieldCode]);">
                <span class="fuzzy-dropdown-item-left">{{data[fcFieldCode]}}</span>
                <span class="fuzzy-dropdown-item-right">{{data[fcLabelCode]}}&nbsp;{{data[fcValueCode]}}</span>
            </li>
        </ul>
    </div>
</div>
    
    `,
    styles: [`
    .fuzzy-dropdown {
        position:relative;
    }
    .fuzzy-dropdown-menu{
        background-color: #fff;
        color:rgba(0, 0, 0, 0.65);
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
        border-radius: 4px; 
        max-height: 250px;
        overflow: auto;
        position: absolute;
        width: 100%;
        top: calc(100% + 2px);
        left: 0px;
        z-index:100;
    }
    .fuzzy-dropdown .fuzzy-dropdown-item {
        padding: 7px 8px;
        cursor:pointer;
        font-weight:normal;
        line-height: 1.5;
        white-space: nowrap;
        display: flex;
        justify-content: space-between;
    }
    .fuzzy-dropdown .active {
        background-color: #f7f7f7;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.65);
    }
    .fuzzy-dropdown-item:hover{
        background-color: #ecf6fd;
    }
    .fuzzy-dropdown-item-left {
        align:left;
    }
    .fuzzy-dropdown-item-right {
        align:right;
    }
    .fc-readonly {
        pointer-events: none;
    }
    :host ::ng-deep .fc-readonly .ant-input{
        background: #f5f5f5;
    }
    :host ::ng-deep [readonly]{
        background: #f5f5f5;
    }
    .form-explain {
        position:relative;
    }
    .explain{
        white-space: nowrap;
        position:absolute;
        right: -1px;
        bottom: 24px;
        z-index:10;
    }
    .explain-inner {
        position:relative;
        color:red;
    }
    .explain-inner:after{
        content: '';
        width: 10px;
        height: 12px;
        display: block;
        background-color: #ffffff;
        border-right: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        position: absolute;
        bottom: -6px;
        right: 12px;
        transform: rotate(45deg);
        z-index: 0;
    }
    .explain-tips{
        padding: 0px 10px;
        background-color: #ffffff;
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        font-size: 12px;
        height: 30px;
        line-height: 28px;
    }
    `],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FctextareaComponent),
        multi: true
    }]
})
export class FctextareaComponent extends FcinputComponent implements AfterViewInit {
    @ViewChild("infocus", {static: false})
    infocus: any;
    // æ¯å¦è·åé»è®¤ç¦ç¹
    @Input()
    fcAutoFocus: string;
    /** èªå¨å®æå³é­èæ³è¾å¥*/
    @Input()
    fcAutoComplete: string;
    /**æ§å¶åºå®æ¡çè¡æ°*/
    @Input()
    fcRow: string;
    _row: number;

    /**æ¯å¦èªéåºåå®¹é«åº¦*/
    @Input()
    fcAutosize: string;
    _Autosize: boolean;
    /**labelå­æ®µåç§°*/
    @Input()
    fcLabelCode: string;

    _timeOut: boolean = false;
    /**valueå­æ®µåç§°*/
    @Input()
    fcValueCode: string;
    /**èæ³è¾å¥æ°æ®*/
    _selectData: any[];
    constructor(public provider: ProvidersService, public ref: ElementRef, public renderer: Renderer) {
        super(provider, 'fc-textarea');
        this._innerValue = null;
        this.fcAutoComplete = "N";

        this.fcAutoFocus = "N";
        this._selectData = [];
    }

    ngAfterViewInit() {
        if (this.infocus && this.fcAutoFocus == "Y") {
            this.renderer.invokeElementMethod(this.infocus.nativeElement, 'focus');
        }
    }
    _afterParentInit() {
        this._innerValue = this._innerValue || '';
        this.fcType = "textarea";
        if (this.fcRow !== undefined) {
            this._row = parseInt(this.fcRow);
        }else{
            this._row = 1;
        }
        if (this.fcRow === undefined && this.fcAutosize !== undefined) {
            if (this.fcAutosize === 'Y') {
                this._Autosize = true;
            } else if (this.fcAutosize === 'N') {
                this._Autosize = false;
            }
        }else{
            this._Autosize = false;
        }
        /**æ¯å¦ç¦ç¨*/
        if (this.fcDisabled === 'Y') {
            this._disabled = true;
        } else {
            this._disabled = false;
        }
        /**æ¯å¦åªè¯»*/
        if (this.fcReadonly === 'Y') {
            this._readonly = true;
        } else {
            this._readonly = false;
        }
        /**æé¿è¾å¥*/
        if (this.fcMaxlen !== undefined) {
            this._maxlen = Number(this.fcMaxlen);
        }
        /**æç­è¾å¥*/
        if (this.fcMinlen !== undefined) {
            this._minlen = Number(this.fcMinlen);
        } 

    }
    _keyup(event) {
        if (event.keyCode == 13) {
            this._selectData = [];
        } else {
            this._searchRemoteValue(event);
        }

        super._keyup(event);
    }
    /**
   * 
   * @param event {click}æåºç¹å»äºä»¶
   */
    _click(event: any) {
        super._click(event);
        this._searchRemoteValue({});
    }
    /**
     * èæ³æ¥è¯¢
     * @param event 
     */
    _searchRemoteValue(event: any) {
        if (!this.fcAutoComplete && this.fcAutoComplete === 'Y') {
            return;
        }
        if (this.fcOption) {
            this._selectData = this.fcOption;
        }
        if (this.fcAppid && this.fcFieldCode) {
            if (!this._timeOut) {
                this._timeOut = true;
                if (this._innerValue === undefined || this._innerValue === null || this._innerValue === "") {
                    this._selectData = [];
                    return;
                }
                setTimeout(() => {
                    this._selectData = [];
                    if (this._selectData === undefined || this._selectData.length === 0) {
                        let observ = this.appService.findWithQuery(this.fcAppid, { PAGESIZE: 1000, PAGENUM: 1, WHERE: "{\"" + this.fcFieldCode + "\":{like:\"%" + this._innerValue + "%\"}}" });
                        this.pushDestroy(observ.subscribe(result => {
                            this._timeOut = false;
                            if (result.CODE === '0') {
                                this._selectData = result.DATA;
                            }
                        }));
                    } else {
                        this._timeOut = false;
                    }
                }, 400);
            } else {
                this._timeOut = false;
            }
        }
    }
}